const env = {
  apiUrl: "https://proposals-api.furnishr.com/api/v1/",
  domain: "go.furnishr.com",
  domainFe: "https://go.furnishr.com",
  domainFeAdmin: "https://admin.furnishr.com"
}

export default env
